import { enqueueSnackbar } from 'notistack';
import { DownloadAgentParams } from '../../pages/userAgent/promtChat/PromtChat';

export interface ValidationError {
  detail:
    | {
        json: {
          [fieldName: string]: string[];
        };
      }
    | string;
  message: string;
}
export interface ApiError extends Error {
  status?: number;
  data?: ValidationError;
}

const validationErrorMessage = (error: ApiError) => {
  if (error.data?.detail && typeof error.data.detail !== 'string' && error.data.detail.json) {
    const fields = error.data.detail.json;
    for (const fieldName in fields) {
      const errorMessages = fields[fieldName];
      if (Array.isArray(errorMessages) && errorMessages.length > 0) {
        return errorMessages[0] || error.message;
      }
    }
  }

  if (error.data?.detail) {
    return error.data.detail;
  }

  if (error.message) {
    return error.message;
  }

  if (typeof error.data === 'string') {
    try {
      const parsedError = JSON.parse(error.data);
      return parsedError.detail || 'error';
    } catch {
      return 'error';
    }
  }

  return 'error';
};

export const showSnackbarErrorMessage = (error: ApiError) => {
  enqueueSnackbar(validationErrorMessage(error).toString(), {
    variant: 'error',
  });
};

export const downloadAgent = async (
  agentDetails: DownloadAgentParams,
  downloadAgentMutation: (params: DownloadAgentParams) => {
    unwrap: () => Promise<Blob>;
  }
) => {
  enqueueSnackbar(`Downloading ${agentDetails.agentName} for you.`);

  try {
    const sanitizedName = agentDetails.agentName.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
    const filename = sanitizedName ? `${sanitizedName}.zip` : 'agent.zip';
    // Check if this is an external agent with a direct download URL
    if (agentDetails.custom_ui === 'external' && agentDetails.download_url && agentDetails.download_url.trim() !== '') {
      // Handle direct URL download
      const link = document.createElement('a');
      link.href = agentDetails.download_url;
      link.download = filename;
      link.target = '_blank'; // Open in new tab as fallback
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Update download count
      await downloadAgentMutation({
        partyId: agentDetails.partyId,
        agentName: agentDetails.agentName,
      });

      enqueueSnackbar(`Downloaded ${agentDetails.agentName}`, {
        variant: 'success',
      });
    } else {
      type DownloadAgentResponse = { blob_url: string };
      const response: Blob | DownloadAgentResponse = await downloadAgentMutation({
        partyId: agentDetails.partyId,
        agentName: agentDetails.agentName,
      }).unwrap();

      if (typeof response === 'object' && 'blob_url' in response) {
      const blobUrl = (response as { blob_url: string }).blob_url;
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

        enqueueSnackbar(`Downloaded ${agentDetails.agentName}`, {
          variant: 'success',
        });
      } else {
        enqueueSnackbar(`Error: Downloaded file not found for ${agentDetails.agentName}.`, { variant: 'error' });
      }
    }
  } catch (err) {
    console.error('Error downloading agent:', err);
    enqueueSnackbar(`Error downloading ${agentDetails.agentName}. Please try again.`, { variant: 'error' });
  }
};

export const agentFinderChatBotId = 'cc765fcf-e799-4061-852e-a443d7e4ce44';
